<template>
  <div>
    <!-- search + breadcrum -->
    <div class="row align-items-center">
      <!-- breadcrum -->
      <ol class="breadcrumb breadcrumb-alt col-12">
        <li @click="rollback(val, index)" v-for="(val, index) of breadcrumb" :key="index" class="breadcrumb-item">
          <a class="link-fx" href="javascript:void(0)">{{ val.name }}</a>
        </li>
      </ol>
      <!-- search -->
      <form v-on:submit.prevent class="d-none d-md-inline-block col-12" style="width: 20rem">
        <div class="input-group input-group-sm">
          <input
            type="text"
            class="form-control"
            placeholder="Recherche..."
            id="search"
            name="search"
            v-model="researchValue"
            style="background-color: #fcfcfc; padding: 12px; width: 100%; border: none"
            @input="searchInput"
          />
          <!-- <span class="input-group-text">
            <i class="fa fa-fw fa-search"></i>
          </span> -->
        </div>
        <v-app style="height: 4px; background-color: transparent;">
            <v-progress-linear v-if="loading" indeterminate color="#3E4254"></v-progress-linear>
        </v-app>
      </form>
    </div>
    <!-- <v-progress-linear indeterminate color="yellow darken-2" style="width: 100%"></v-progress-linear> -->
    <!-- Category -->
    <div class="mt-2" v-if="showCategories">
      <!-- Categories 'Type Object' - Catégories -->
      <div v-if="!Array.isArray(actualCards)" class="row items-push">
        <div
          v-for="(value, name) in actualCardsWithoutColor"
          :key="name"
          @click="nextStep(value, name, value?.id)"
          class="col-4 col-md-3 mb-0"
        >
          <div
            class="block block-rounded rounded-24 h-100 mb-0 ratio ratio-1x1"
            :style="hasCustomColor(value) ? `background-color: ${getCustomBackgroundColor(value)}` : 'background-color: #FFF'"
            role="button"
          >
            <div class="block-content d-flex justify-content-center align-items-center" style="flex-direction: column">
                <!-- new -->
                <!-- Bons cadeau -->
                <i v-if="name == 'Bons cadeau'"
                  class="bi bi-gift-fill"
                  style="font-size: 42px;"></i>

                <!-- Prestations -->
                <i v-if="name == 'Prestations'"
                  class="bi bi-person-fill"
                  style="font-size: 42px;"></i>

                <!-- Abonnements -->
                <i v-if="name == 'Abonnements'"
                  class="bi bi-arrow-repeat"
                  style="font-size: 42px;"></i>

                <!-- Produits -->
                <i v-if="name == 'Produits'"
                  class="bi bi-box-seam-fill"
                  style="font-size: 42px;"></i>

                <!-- Cures -->
                <i v-if="name == 'Cures'"
                  class="bi bi-heart-pulse-fill"
                  style="font-size: 42px;"></i>

                <!-- Forfaits -->
                <i v-if="name == 'Forfaits'"
                  class="bi bi-layers-fill"
                  style="font-size: 42px;"></i>
                
                  <!-- Montants -->
                <i v-if="name == 'Montant fixe'"
                  class="bi bi-currency-euro"
                  style="font-size: 42px;"></i>

                <span
                  class="h5 pt-3 text-center"
                  :style="{
                    color: getSmartTextColor(getCustomBackgroundColor(value))
                  }"
                  >
                    {{ name }}
                  </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Categories 'Type Array' - Sous-catégories -->
      <div v-else class="row items-push">
        <div
          v-for="(value, index) of actualCardsWithoutColor"
          :key="index"
          v-if="value && value.id"
          @click="nextStep(value, value.name, value.id, true)"
          style="margin-bottom: 0px"
          class="col-4 col-md-3"
        >
          <div
              class="block block-rounded h-100 mb-0 ratio ratio-1x1"
              :style="{
                backgroundColor: value.color || '#3e4254'
              }"
              role="button"
            >
            <div class="block-content d-flex justify-content-center align-items-center">
              <p
                    class="h5 text-center mb-0"
                    :style="{
                      color: value.color ? getSmartTextColor(value.color || null) : '#fff'
                    }"
                  >
                {{ value.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Prestations & Produits -->
    <div v-else class="row items-push mt-4">
      <div v-if="noResults">
        <p>Aucun résultat pour cette sous-catégorie.</p>
      </div>
      <div v-if="!actualCardsWithoutColor.length && researchValue && !loading">
        Ancun résultat trouvé
      </div>
      <div v-for="(value, index) in actualCardsWithoutColor" :key="value.id" class="col-4" v-if="value && value.id">
        <form v-if="!isVoucher" method="POST" :action="prestaAdd">
          <input type="hidden" name="_token" :value="csrf" ref="_token" />
          <input type="hidden" name="type" :value="currentCategory || value.cat" />
          <input type="hidden" name="item_id" :value="value.id" />
          <!-- <input type="hidden" name="price_ht" :value="value.price_ht" /> -->
          <input type="hidden"
            name="price_ht"
            :value="value.discount_price > 0
            ? (value.price_ht - value.discount_price)
            : value.price_ht" 
          />
          <input v-if="orderId" type="hidden" name="order_id" :value="orderId" />
          <input v-if="userId" type="hidden" name="user_id" :value="userId" />
          <button type="submit" style="width: 100%;">
            <div class="block block-rounded h-100 mb-0">
              <div class="block-content position-relative p-1">
                <!-- <span class="badge rounded-pill bg-primary" style="position: absolute; top: -10px; right: -10px; z-index: 2"
                  >{{ value.price }}€
                </span> -->
                <span v-if="value.discount_price > 0"
                  class="badge rounded-pill bg-danger"
                  style="position: absolute; top: -10px; right: -10px; z-index: 2; padding: 6px 12px">

                  <strike class="text-light" style="font-size: 0.8rem;">
                    {{ value.price }}€
                  </strike>
                  <br>
                  <span class="fw-bold">
                    {{ value.price - value.discount_price }}€
                  </span>

                </span>
                <span v-else
                    class="badge rounded-pill bg-primary"
                    style="position: absolute; top: -10px; right: -10px; z-index: 2; padding: 6px 12px">

                  {{ value.price }}€

                </span>
                <div class="options-container">
                  <img
                    style="height: 160px;width: 100%;object-fit: cover;"
                    class="p-0 img-thumbnail options-item"
                    v-if="value.img1"
                    :src="value?.img1 || '/media/default.jpg'"
                    :alt="value.name"
                  />
                  <img
                    style="height: 160px;width: 100%;object-fit: cover;"
                    class="p-0 img-thumbnail options-item"
                    v-else
                    :src="value?.image || '/media/default.jpg'"
                    :alt="value.name"
                  />
                </div>
              </div>
              <div class="block-content">
                <!-- #TODO Définir si l'on trie dans le controler les produit et prestations non vendable {{ value}} -->
                <div class="mb-1">
                  <!-- <input
                    type="hidden"
                    id="priceModalPresta"
                    name="priceModalPresta"
                    :value="value.price"
                    ref="priceModalPresta"
                  /> -->
                  <input type="hidden"
                    id="priceModalPresta"
                    name="priceModalPresta"
                    :value="value.discount_price > 0
                    ? (value.price - value.discount_price)
                    : value.price" 
                  />
                  <p class="h6">{{ value?.name }}</p>
                  <input type="hidden" id="prestationLabel" name="prestationLabel" :value="value.name" ref="prestationLabel" />
                  <input
                    type="hidden"
                    id="quantity"
                    name="quantity"
                    onchange="this.form.submit()"
                    class="input-number"
                    min="1"
                    value="1"
                    ref="quantity"
                  />
                </div>
                <p v-if="isPrestation" class="fs-sm text-muted">{{ value.commercial_time }} min</p>
                <p v-if="isProduct" class="fs-sm text-muted">Quantité disponible : {{ value.quantity }}</p>
                <input type="hidden" id="timeQty" name="timeQty" :value="value.duration" ref="timeQty" />
                <input type="hidden" id="prestaStatus" name="prestaStatus" value="1" ref="prestaStatus" />
              </div>
            </div>
          </button>
        </form>

        <!-- bon cadeau -->
        <form v-else method="POST" :action="voucherAdd" ref="formPrestaAdd">
          <input type="hidden" name="_token" :value="csrf" ref="_token" />
          <input type="hidden" name="type" :value="value.cat" />
          <input type="hidden" name="item_id" :value="value.id" />
          <input type="hidden" name="amount" :value="amount" />
          <input v-if="orderId" type="hidden" name="order_id" :value="orderId" />
          <input v-if="userId" type="hidden" name="user_id" :value="userId" />
          <input type="hidden" name="bonCadeau" :value="true" />

            <div class="block block-rounded h-100 mb-0">
              <div class="block-content position-relative p-1">
                <span class="badge  bg-primary" style="position: absolute; top: -10px; right: -10px; z-index: 2"
                  >{{ value.price }}€</span
                >
                <div class="options-container">
                  <img
                    style="height: 160px;width: 100%;object-fit: cover;"
                    class="p-0 img-thumbnail options-item"
                    :src="value?.image || '/media/default.jpg'"
                    :alt="value.name"
                  />
                </div>
              </div>
              <div class="block-content">
                <div class="mb-1">
                  <input
                    type="hidden"
                    id="priceModalPresta"
                    name="priceModalPresta"
                    :value="value.price"
                    ref="priceModalPresta"
                  />
                  <p class="h6">{{ value.name }}</p>
                  <input type="hidden" id="prestationLabel" name="prestationLabel" :value="value.name" ref="prestationLabel" />
                  <input
                     v-if="isPrestation"
                    type="number"
                    id="quantity"
                    name="quantity"
                    class="input-number"
                    min="1"
                    value="1"
                    ref="quantity"
                  />
                  <input
                     v-else
                    type="hidden"
                    id="quantity"
                    name="quantity"
                    class="input-number"
                    min="1"
                    value="1"
                    ref="quantity"
                  />
                </div>
                <p v-if="isPrestation" class="fs-sm text-muted">{{ value.commercial_time }} min</p>
                <input type="hidden" id="timeQty" name="timeQty" value="30" ref="timeQty" />
                <input type="hidden" id="prestaStatus" name="prestaStatus" value="1" ref="prestaStatus" />
              </div>
              <button type="submit" class="btn btn-primary" style="width: 100%;">valider</button>
            </div>
        </form>

        <div :id="{ 'modal-overlay': modalVoucher }"></div>
      </div>
    </div>
    <div
      v-if="fixedAmount"
      class="modal fade"
      :class="{ show: fixedAmount }"
      id="modalVoucher"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalVoucherLabel"
      aria-hidden="true"
      style="display: block"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content rounded-24 overflow-hidden">
          <div class="block  rounded-24 block-transparent mb-0">
            <div class="block-header">
              <h3 class="block-title fs-3 d-flex justify-content-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22.772" height="20.675" viewBox="0 0 25.772 27.675" style="display: inline-block;margin: 0 5px;">
                      <path id="gift-svgrepo-com" d="M39.414,4.525H38.152c0-1.418-.058-2.739-.955-3.637A3.509,3.509,0,0,0,34.583,0a9.611,9.611,0,0,0-6.62,2.777A9.611,9.611,0,0,0,21.343,0a3.509,3.509,0,0,0-2.613.888c-.9.9-.954,2.22-.955,3.637H16.512a.935.935,0,0,0-.935.935V26.74a.935.935,0,0,0,.935.935h22.9a.935.935,0,0,0,.935-.935V5.46A.935.935,0,0,0,39.414,4.525Zm-.935,4.911H31.352V6.4h7.128ZM26.444,6.4h3.038V16.536l-1-.667a.934.934,0,0,0-1.037,0l-1,.667V6.4Zm8.14-4.526a1.846,1.846,0,0,1,1.29.339,3.808,3.808,0,0,1,.409,2.317H29.031C29.648,3.206,32.3,1.87,34.583,1.87Zm-14.531.339a1.845,1.845,0,0,1,1.29-.339c2.284,0,4.935,1.337,5.552,2.656H19.644A3.807,3.807,0,0,1,20.052,2.209ZM24.574,6.4V9.436H17.447V6.4Zm-7.128,19.41v-14.5h7.128v6.977a.935.935,0,0,0,1.454.778l1.935-1.291L29.9,19.061a.935.935,0,0,0,1.454-.778V11.306h7.128v14.5Z" transform="translate(-15.577)"></path>
                  </svg>Bon cadeau</h3>
<!--              <div class="block-options">
                <button type="button" class="btn-block-option" @click="closeVoucherModal">
                  <i class="fa fa-fw fa-times"></i>
                </button>
              </div>-->
            </div>
            <form :action="voucherAdd" method="POST">
              <div class="block-content d-flex flex-column fs-sm mb-4">
                <input type="hidden" name="_token" :value="csrf" ref="_token" />
                <input type="hidden" name="type" :value="currentCategory" />
                <input v-if="orderId" type="hidden" name="order_id" :value="orderId" />
                <input v-if="userId" type="hidden" name="user_id" :value="userId" />
                <input
                  type="hidden"
                  id="prestationLabel"
                  name="prestationLabel"
                  :value="'Bon cadeau de ' + amount + '€'"
                  ref="prestationLabel"
                />
                 <label class="form-label" for="amount">
                      Quantité
                      <span class="text-danger">*</span>
                    </label>
                <input
                  type="number"
                  id="quantity"
                  name="quantity"
                  class="input-number rounded-24 w-25"
                 style="min-width: 100px"
                  min="1"
                  value="1"
                  ref="quantity"
                />
                <div class="row">
                  <div class="col-12">
                    <label class="form-label" for="amount">
                      Montant de votre bon cadeau
                      <span class="text-danger">*</span>
                    </label>
                    <div class="input-group rounded-24 overflow-hidden">
                      <span class="input-group-text bg-primary text-white border-0 px-3">€</span>
                      <input
                        type="number"
                        min="1"
                        step="0.01"
                        class="form-control "
                        style="border-radius: 0 24px 24px 0"
                        id="amount"
                        name="amount"
                        placeholder="Montant"
                        v-model="amount"
                      />
                      <input type="hidden" id="priceModalPresta" name="priceModalPresta" :value="amount" ref="priceModalPresta" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="block-content block-content-full text-center">
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  style="min-width: 120px"
                  class="btn btn-sm btn-alt-secondary me-1  py-2 px-3"
                  @click="closeVoucherModal"
                >
                  Fermer
                </button>
                <button type="submit" class="btn btn-sm btn-yellow  py-2 px-3">Ajouter au bon cadeau</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-if="modalVoucher || fixedAmount" :class="{ show: modalVoucher || fixedAmount }" class="modal-backdrop fade"></div>
  </div>
</template>

<style>
input[type="number"]
{
  -moz-appearance: none;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
}
.v-application--wrap {
  flex: 1 1 auto;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  min-height: 20vh;
  max-width: 100%;
  position: relative;
}
</style>

<script>
/*
 *   Categories:
 */

export default {
  props: [
    'prestaAdd',
    'voucherAdd',
    'getPrestationsBySubcategory',
    'getPrestationsByVoucherSubcategory',
    'getProductsBySubcategory',
    'categories',
    'questions',
    'researchRoute',
    'currentCustomer',
    'orderId',
    'userId'
  ],
  name: 'checkout-component',
  components: {
    DialogAlerte: () => import('../Calendar/Modal/parts/DialogAlerte.vue'),
  },
  data: () => ({
    breadcrumb: [],
    actualCards: null,
    showCategories: true,
    csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    isPrestation: false,
    isProduct: false,
    isSerie: false,
    isVoucher: false,
    researchValue: '',
    currentCategory: null,
    noResults: false,
    lastRequest: new Date(),
    loading: false,
    timeout: null,
    alertRebooking: null,

    // Voucher Prestation modal
    modalVoucher: false,
    fixedAmount: false,
    amount: 1,
  }),
  computed: {
    actualCardsWithoutColor: function() {
      if (Array.isArray(this.actualCards)) {
        return this.actualCards.filter(i => typeof i !== 'string')
      }

      return this.actualCards
    },
  },
  mounted() {
    this.actualCards = this.categories
  },
  methods: {
    searchInput() {
        this.loading = true
        if (this.timeout) {
            clearTimeout(this.timeout)
        }
        this.timeout = setTimeout(() => {
            this.research()
            this.loading = false
        }, 500)
    },
    hasCustomColor(value) {
      return typeof value[value.length - 1] === 'string' && value[value.length - 1] !== ''
    },

    getCustomColor(value) {
      // console.log('color value',value[value.length - 1])
      return value[value.length - 1]
    },
    getCustomBackgroundColor(value) {
      // console.log('color value',value[value.length - 1])
      return value[value.length - 1] + 33
    },

    getTextColor(backgroundColor) {
    if (!backgroundColor) return '#000';

    let hex = backgroundColor.replace('#', '');

    if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('');
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    const brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;

    return brightness > 155 ? '#6B5200' : '#FFFFFF';
},
  getSmartTextColor(bgColor) {
    if (!bgColor) return '#222222';

    let hex = bgColor.replace('#', '');

    if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('');
    }

    if (hex.length !== 6) return '#222222';

    let r = parseInt(hex.substring(0,2),16);
    let g = parseInt(hex.substring(2,4),16);
    let b = parseInt(hex.substring(4,6),16);

    const brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;

    if (brightness > 170) {
        // fond clair → texte foncé harmonisé
        r = Math.max(0, r - 140);
        g = Math.max(0, g - 140);
        b = Math.max(0, b - 140);
    } else {
        // fond foncé → texte clair harmonisé
        r = Math.min(255, r + 170);
        g = Math.min(255, g + 170);
        b = Math.min(255, b + 170);
    }

    return `rgb(${r},${g},${b})`;
},

    rollback(val, index) {
      console.log(val)
      if (val.name == 'Prestations' || val.name == 'Prestations') {
        this.isPrestation = false
        this.isProduct = false
      }
      this.isVoucher = false
      this.fixedAmount = false

      this.actualCards = val.previousCategory
      this.breadcrumb = this.breadcrumb.slice(0, index)
      this.showCategories = true
    },

    nextStep(event, name, id, isLastStep = false) {
      console.log(event, name, id)
      switch (name) {
        case 'Prestations':
          if (this.breadcrumb.filter(e => e.name === 'Bons cadeau').length > 0) {
            this.isVoucher = true
          }
          this.currentCategory = name
          this.isPrestation = true

          break

        case 'Produits':
          this.isProduct = true
          this.currentCategory = name
          break
        case 'Abonnements':
          this.currentCategory = name
          isLastStep = true
          break
        case 'Forfaits':
          this.currentCategory = name
          isLastStep = true
          break
        case 'Bons cadeau':
          this.isVoucher = true
          this.currentCategory = name
          break
        case 'Cures':
          this.currentCategory = name
          isLastStep = true
          break
        case 'Montant fixe':
          isLastStep = true
          this.fixedAmount = true
          this.modalVoucher = true
          this.currentCategory = 'Bons cadeau'
          break

        default:
          break
      }
      this.breadcrumb.push({ name: name, id: id, previousCategory: this.actualCards })
      this.actualCards = event

      if (isLastStep && id !== null) {
        this.showCategories = false
        if (this.isPrestation) this.getPrestations(id)
        //if (this.isVoucher) this.getPrestationsVoucher(27)
        if (this.isProduct) this.getProducts(id)
      }
    },

    async research() {
      const targetDate = new Date();
      if (this.researchValue.length > 0) {
        this.loading = true;
        axios
          .get(this.researchRoute, { params: { name: this.researchValue, category: this.currentCategory } })
          .then(res => {
            if (targetDate <= this.lastRequest) return

            this.showCategories = false
            this.actualCards = res.data
            this.lastRequest = targetDate;
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.showCategories = true
        this.currentCategory = null
        this.actualCards = this.categories
        this.breadcrumb.splice(0)
        this.lastRequest = targetDate;
        // switch (this.currentCategory) {
        //   case 'Prestations':
        //     if (this.breadcrumb.filter(e => e.name === 'Bons cadeau').length > 0) {
        //       this.isVoucher = true
        //       console.log('voucher')
        //     }
        //     this.isPrestation = true
        //     this.actualCards = this.categories

        //     break
        //   case 'Produits':
        //     this.isProduct = true
        //     this.actualCards = this.categories
        //     break
        //   case 'Abonnements':
        //     this.showCategories = false
        //     break
        //   case 'Forfaits':
        //     this.showCategories = false
        //     break
        //   case 'Bons cadeau':
        //     this.isVoucher = true
        //     this.actualCards = this.categories
        //     break
        //   case 'Cures':
        //     this.showCategories = false
        //     break

        //   default:
        //     this.showCategories = true
        //     this.actualCards = this.categories
        //     break
        // }
      }
    },

    async getPrestations(subcategory) {
      axios
        .get(this.getPrestationsBySubcategory, { params: { id: subcategory } })
        .then(res => {
          this.actualCards = res.data
          if (res.data.length == 0) {
            this.noResults = true
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    async getPrestationsVoucher(subcategory) {
      axios
        .get(this.getPrestationsByVoucherSubcategory, { params: { id: subcategory } })
        .then(res => {
          this.actualCards = res.data
          if (res.data.length == 0) {
            //this.noResults = true
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    async getProducts(subcategory) {
      axios
        .get(this.getProductsBySubcategory, { params: { id: subcategory } })
        .then(res => {
          this.actualCards = res.data
          if (res.data.length == 0) {
            this.noResults = true
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    openVoucherModal(index) {
      this.$refs.modalVoucher[index].classList.remove('hide')
      this.$refs.modalVoucher[index].classList.add('show')
      this.$refs.modalVoucher[index].style.display = 'block'
      this.modalVoucher = true
    },

    closeVoucherModal(index = null) {
      this.modalVoucher = false
      this.isVoucher = false

      if (this.fixedAmount) {
        this.fixedAmount = false

        // Retour à l'affichage des catégories
        this.showCategories = true
        this.actualCards = this.categories
        this.breadcrumb = []
      } else {
        this.$refs.modalVoucher[index].classList.add('hide')
        this.$refs.modalVoucher[index].classList.remove('show')
        this.$refs.modalVoucher[index].style.display = 'none'
      }
    },

    modalSubmit(index) {
      this.$refs.formPrestaAdd[index].submit()
    },

    blockEnterKey(event) {
      console.log(event)
      event.preventDefault()
      return false
    },
  },
}
</script>

<style></style>
